export default "__VITE_ASSET__16cfacec__"